import axios, {AxiosRequestConfig, AxiosResponse} from 'axios'
import {FilterData, ProductData} from "@/types";

const devMode = process.env.NODE_ENV !== 'production';
const apiClient = axios.create({
    baseURL: devMode ? 'http://clevero.dev.poski.loc' : window.location.origin,
    withCredentials: false,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    }
})

export default {
    prepareFilterData(): Promise<FilterData> {
        const pageSrc = window.location.pathname + window.location.search + (window.location.search === "" ? "?" : "&") + "renderfilter=json";
        return apiClient.get(devMode ? '/eshop/clevero-10003/?renderfilter=json' : pageSrc)
            .then(response => {
                return response.data as FilterData;
            });
    },
    getFilterData(url: string, queryParams?: URLSearchParams): Promise<FilterData> {
        const params = queryParams ?? new URLSearchParams();
        params?.append('renderfilter', 'json');

        return apiClient.get(url, { params: params })
            .then(response => {
                return response.data as FilterData;
            });
    },
    // TODO: volat pouze json s produkty (optimalizace ???)
    getProductList(url: string, queryParams?: URLSearchParams | Record<string, never>): Promise<ProductData> {
        const params = queryParams ?? new URLSearchParams();
        params?.append('renderfilter', 'json');

        return apiClient.get(url, { params: params })
            .then(response => {
                const result = response.data as FilterData;
                return {
                    productsTotal: result.totalProductCount,
                    products: result.products,
                    pager: result.pager.items,
                    nextPageUrl: result.nextPageUrl
                } as ProductData;
            });
    },
    writeHistory(url: string, params?: URLSearchParams) {
        let filteredParams = '';
        if (params && params instanceof URLSearchParams) {
            params.delete('renderfilter');
            filteredParams = '?' + params.toString();
        }

        history.pushState(null, '', url + filteredParams);
    }
}